import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';

const selection = (state: RootState) => state.error;

export default function useErrorState() {
  const state = useSelector(selection);
  return state;
}
